"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderLayoutElements = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@jsonforms/react");
const antd_1 = require("antd");
const renderLayoutElements = (elements, schema, path, enabled, renderers, cells, direction) => {
    return elements.map((child, index) => {
        if (direction === "row") {
            return ((0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, sm: 12, children: (0, jsx_runtime_1.jsx)(react_1.JsonFormsDispatch, { uischema: child, schema: schema, path: path, enabled: enabled, renderers: renderers, cells: cells }, `${path}-${index}`) }, `${path}-${index}`));
        }
        return ((0, jsx_runtime_1.jsx)(react_1.JsonFormsDispatch, { uischema: child, schema: schema, path: path, enabled: enabled, renderers: renderers, cells: cells }, `${path}-${index}`));
    });
};
exports.renderLayoutElements = renderLayoutElements;
